"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ApprovalClient_1 = require("client/ApprovalClient");
const UserContext_1 = require("context/UserContext");
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const TextAreaWithMention_1 = __importDefault(require("components/shared/TextAreaWithMention/TextAreaWithMention"));
const ModalApprove = ({ isReject = false, setShowApprove, countState, teamId, objectiveId, approvalId, eventOnApproveOrReject, teamName, teamPicture }) => {
    const [showReasonModal, setShowReasonModal] = (0, react_1.useState)(false);
    const { user } = (0, UserContext_1.useUser)();
    const [metaMentions, setMetaMentions] = (0, react_1.useState)([]);
    const [comment, setComment] = (0, react_1.useState)('');
    const handleClickApprove = async (isReject = false) => {
        let params = {
            teamId: teamId,
            objectiveId: objectiveId
        };
        if (isReject) {
            const metaMentionsPayload = metaMentions.map((value) => {
                return {
                    userId: value?.userId,
                    startIndex: value?.startIndex,
                    length: value?.length
                };
            });
            params = {
                ...params,
                comment: comment,
                metaMentions: metaMentionsPayload
            };
        }
        const { isSuccess } = isReject
            ? await (0, ApprovalClient_1.rejectApprovalById)(approvalId, params)
            : await (0, ApprovalClient_1.approveApprovalById)(approvalId, params);
        if (isSuccess) {
            setShowApprove(false);
            eventOnApproveOrReject();
        }
    };
    return showReasonModal ? (react_1.default.createElement(Modal_1.default, { onClose: () => setShowReasonModal(false) },
        react_1.default.createElement(Modal_1.default.Header, { title: "Reason" }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "body-approval w-full px-[24px]" },
                react_1.default.createElement("p", { className: "typography-paragraph mb-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Reason (Required)')),
                react_1.default.createElement(TextAreaWithMention_1.default, { currentUserId: user?.id, setComment: setComment, metaMentions: metaMentions, setMetaMentions: setMetaMentions, source: "modal", customClass: "min-h-[88px]" }))),
        react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Reject All'),
                onClick: () => handleClickApprove(true),
                dataCy: 'approval-reason-modal-action'
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                onClick: () => setShowReasonModal(false),
                dataCy: 'approval-reason-modal-cancel'
            }, useBorder: false }))) : (react_1.default.createElement(Modal_1.default, { onClose: () => setShowApprove(false), minWidth: 400, customClass: "w-[400px]" },
        react_1.default.createElement(Modal_1.default.Header, { title: isReject ? 'Reject' : 'Approve' }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "flex flex-col w-full px-[24px]" },
                react_1.default.createElement("p", { className: "typography-paragraph text-n-800 mb-[16px]" }, (0, HelperUtils_1.getObjectiveLocale)(`You will ${isReject ? 'reject' : 'approve'} these objectives:`)),
                react_1.default.createElement("div", { className: "flex justify-between items-center bg-n-200 px-[16px] py-[8px] rounded-[4px] mb-[8px]" },
                    react_1.default.createElement("p", { className: "typography-paragraph" }, (0, HelperUtils_1.getObjectiveLocale)('New')),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" }, `${countState?.draft} ${(0, HelperUtils_1.getObjectiveLocale)('objective')}(s)`)),
                react_1.default.createElement("div", { className: "flex justify-between items-center bg-n-200 px-[16px] py-[8px] rounded-[4px] mb-[8px]" },
                    react_1.default.createElement("p", { className: "typography-paragraph" }, (0, HelperUtils_1.getObjectiveLocale)('Edited')),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" }, `${countState?.edited} ${(0, HelperUtils_1.getObjectiveLocale)('objective')}(s)`)),
                react_1.default.createElement("div", { className: "flex justify-between items-center bg-n-200 px-[16px] py-[8px] rounded-[4px] mb-[8px]" },
                    react_1.default.createElement("p", { className: "typography-paragraph" }, (0, HelperUtils_1.getObjectiveLocale)('to_be_deleted')),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" }, `${countState?.toBeDeleted} ${(0, HelperUtils_1.getObjectiveLocale)('objective')}(s)`)),
                react_1.default.createElement("div", { className: "flex justify-between items-center bg-n-200 px-[16px] py-[8px] rounded-[4px]" },
                    react_1.default.createElement("p", { className: "typography-paragraph" }, (0, HelperUtils_1.getObjectiveLocale)('Existing')),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" }, `${countState?.existing} ${(0, HelperUtils_1.getObjectiveLocale)('objective')}(s)`)))),
        react_1.default.createElement(Modal_1.default.Footer, { userInfo: {
                profilePicture: teamPicture,
                name: teamName,
                dataCy: 'team-info'
            }, primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)(`${isReject ? 'Reject' : 'Approve'} All`),
                onClick: () => isReject ? setShowReasonModal(true) : handleClickApprove(false),
                dataCy: 'confirm'
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                onClick: () => setShowApprove(false),
                dataCy: 'cancel-delete'
            }, useBorder: false })));
};
exports.default = ModalApprove;
